import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { MenuItem, Typography } from "@mui/material";
import { BLACK } from "../../../constants/Colors";
import { ChangeFirstLetter } from "../../../utils/Functions";

export default function CustomSelectField(props) {
  const { labelName, isMultiline, placeholder, data, setCurrentCategory,previousCategory } =
    props;

  const [selectedCategory, setSelectedCategory] = useState({
    categoryId: previousCategory.categoryId,
    categoryName: previousCategory.categoryName,
  });

  const handleChange = (e) => {
    const selectedCategoryName = e.target.value;
    const selectedObject = data.find(
      (value) => value.categoryName === selectedCategoryName
    );

    if (selectedObject) {
      setCurrentCategory({
        categoryId: selectedObject.categoryId,
        categoryName: selectedObject.categoryName,
      });

      setSelectedCategory(selectedObject);
    } else {
      console.error("Selected categoryName not found in data array");
    }
  };

  

  return (
    <>
      <Typography
        variant={"caption"}
        style={{ lineHeight: 1 }}
        color={"textSecondary"}
      >
        {labelName}
      </Typography>
      <TextField
        margin="dense"
        size={"small"}
        sx={{
          color: "#333",
          "& input[type=number]": {
            "-moz-appearance": "textfield",
          },
          "& input[type=number]::-webkit-outer-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
          },
          "& input[type=number]::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
          },
          marginTop: "-2px",
        }}
        fullWidth
        variant="outlined"
        {...props}
        placeholder={placeholder}
        onChange={handleChange}
        multiline={isMultiline}
        rows={4}
        value={selectedCategory ? selectedCategory.categoryName : ""}
      >
        {data?.map((value, index) => (
          <MenuItem
            key={index}
            value={value.categoryName}
            sx={{
              color: BLACK,
              fontSize: 18,
              "&:hover": {
                // backgroundColor: BLACK_LIGHT,
              },
            }}
          >
            {ChangeFirstLetter(value.categoryName)}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}
